import PageRenderer from '../../components/PageRenderer/PageRenderer';

function Experience() {
  return <PageRenderer pageKey="experience" />;
}

export default Experience;
